const carousel1 ={
    carousel_1 : "Images/Login_carosel/carosel1.png"
};
export default carousel1
